import RequestStatus from 'src/model/RequestStatus';
import {
  ADDITIONAL_INFO_QUERY_SUCCESS,
  GetSelectedProductQueryComplete,
  SELECTED_PRODUCT_QUERY_FAILED,
  SELECTED_PRODUCT_QUERY_START,
  SELECTED_PRODUCT_QUERY_SUCCESS,
  SELECTED_PRODUCT_QUERY_UPDATING,
  SELECTED_PRODUCT_REMOVE,
  SWITCH_AMAZON_STORE_START_NEW,
} from 'src/actions/SelectedProductQueryAction';
import { GetSelectedProductResponse } from 'src/model/ProductMatch';
import { AdditionalInfo } from 'src/model/AdditionalInfo';

const initialState: GetSelectedProductResponse = {
  requestStatus: RequestStatus.NOT_LOADED,
  data: null,
};

export default (
  state: GetSelectedProductResponse = initialState,
  action: GetSelectedProductQueryComplete,
): GetSelectedProductResponse => {
  switch (action.type) {
    case SELECTED_PRODUCT_QUERY_START:
      return {
        requestStatus: RequestStatus.LOADING,
        data: null,
      };
    case SELECTED_PRODUCT_QUERY_UPDATING:
      return {
        requestStatus: RequestStatus.UPDATING,
        data: action.selectedProductData,
      };
    case SELECTED_PRODUCT_QUERY_SUCCESS:
      return {
        requestStatus: RequestStatus.SUCCESS,
        data: action.selectedProductData, // TODO: merge fields
      };
    case ADDITIONAL_INFO_QUERY_SUCCESS: {
      //selectedProductData is AdditionalInfo
      const additionalInfo: AdditionalInfo = action.selectedProductData.data;
      const productData = {
        ...state.data,
      };
      const selectedProduct = productData.selectedProduct;
      selectedProduct.winOfferFulfillerName = additionalInfo.shipsFrom;
      selectedProduct.winOfferMerchantName = additionalInfo.soldBy;
      selectedProduct.winOfferPriceAmount = additionalInfo.price?.amount;
      selectedProduct.winOfferPriceCurrencyCode =
        additionalInfo.price?.currency;
      selectedProduct.winOfferShippingAmount = additionalInfo.shipping?.amount;
      selectedProduct.winOfferCondition = additionalInfo.condition;
      if (additionalInfo.length && additionalInfo.length > 0) {
        selectedProduct.length = additionalInfo.length;
        selectedProduct.width = additionalInfo.width;
        selectedProduct.height = additionalInfo.height;
        selectedProduct.dimensionUnit = additionalInfo.dimensionUnit;
        selectedProduct.weight = additionalInfo.weight;
        selectedProduct.weightUnit = additionalInfo.weightUnit;
      }

      return {
        requestStatus: RequestStatus.SUCCESS,
        data: productData,
      };
    }
    case SELECTED_PRODUCT_QUERY_FAILED:
      return {
        requestStatus: RequestStatus.ERROR,
        data: state.data,
      };
    case SELECTED_PRODUCT_REMOVE:
    case SWITCH_AMAZON_STORE_START_NEW:
      return initialState;
    default:
      return state;
  }
};
